import { FC, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../modules/auth'
import { useSystemSettings } from '../../modules/system-settings/SystemSettingsContext'
import { KIOSK_PAGES, canAccessKioskPage, findKioskPage } from './kioskAccess'

/**
 * Enforces the same policy rules on kiosk routes that KioskLayout applies to
 * its header buttons. Without this a user can land on (or navigate to) a
 * kiosk page whose button is hidden for them.
 */
const KioskRouteGuard: FC<{ children: ReactNode }> = ({ children }) => {
  const { currentUser } = useAuth()
  const { policies: systemPolicies, isLoading } = useSystemSettings()
  const location = useLocation()

  const page = findKioskPage(location.pathname)
  if (!page) return <>{children}</>

  if (isLoading) return null

  if (canAccessKioskPage(page, currentUser?.policyIds, systemPolicies)) {
    return <>{children}</>
  }

  const fallback = KIOSK_PAGES.find(
    (p) => p !== page && canAccessKioskPage(p, currentUser?.policyIds, systemPolicies)
  )
  return <Navigate to={fallback ? fallback.path : '/kiosk'} replace />
}

export { KioskRouteGuard }
